export const TOGGLE_RESTRICTED = 'fulcrum/containers/Restricted/TOGGLE_RESTRICTED'
export const INIT_UI_RESTRICTED = 'fulcrum/containers/Restricted/INIT_RESTRICTED'
export const TOGGLE_UI_RESTRICTED = 'fulcrum/containers/Restricted/TOGGLE_UI_RESTRICTED'
export const RESET_UI_RESTRICTED = 'fulcrum/containers/Restricted/RESET_UI_RESTRICTED'
